import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ChatBubble from './ChatBubble';
import './GuestLayout.css';

const GuestLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className="guest-layout">
      {/* Top Navigation Bar */}
      <header className="guest-sidebar">
        {/* Logo */}
        <div className="sidebar-header">
          <Link to="/guest" className="logo">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <polyline points="9 22 9 12 15 12 15 22" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="logo-text">InnBotics</span>
          </Link>
        </div>

        {/* Navigation Links */}
        <nav className="sidebar-nav">
          <Link
            to="/guest"
            className={`nav-item ${isActive('/guest') ? 'active' : ''}`}
          >
            <svg viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="7" height="7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <rect x="14" y="3" width="7" height="7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <rect x="14" y="14" width="7" height="7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <rect x="3" y="14" width="7" height="7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="nav-label">Dashboard</span>
          </Link>

          <Link
            to="/booking"
            className={`nav-item ${isActive('/booking') ? 'active' : ''}`}
          >
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="10" r="3" strokeWidth="2"/>
            </svg>
            <span className="nav-label">Browse Hotels</span>
          </Link>

          <Link
            to="/my-bookings"
            className={`nav-item ${isActive('/my-bookings') ? 'active' : ''}`}
          >
            <svg viewBox="0 0 24 24" fill="none">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" strokeWidth="2"/>
              <line x1="16" y1="2" x2="16" y2="6" strokeWidth="2" strokeLinecap="round"/>
              <line x1="8" y1="2" x2="8" y2="6" strokeWidth="2" strokeLinecap="round"/>
              <line x1="3" y1="10" x2="21" y2="10" strokeWidth="2"/>
            </svg>
            <span className="nav-label">My Bookings</span>
          </Link>

          <Link
            to="/guest-profile"
            className={`nav-item ${isActive('/guest-profile') ? 'active' : ''}`}
          >
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="7" r="4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="nav-label">Profile</span>
          </Link>
        </nav>

        {/* User info — auto-pushed to right */}
        <div className="sidebar-user">
          <div className="user-avatar">
            {currentUser?.displayName?.charAt(0).toUpperCase() || currentUser?.email?.charAt(0).toUpperCase() || 'G'}
          </div>
          <div className="user-info">
            <div className="user-name">{currentUser?.displayName || 'Guest'}</div>
            <div className="user-role">guest</div>
          </div>
        </div>

        {/* Logout */}
        <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-btn">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <polyline points="16 17 21 12 16 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="21" y1="12" x2="9" y2="12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Logout</span>
          </button>
        </div>
      </header>

      {/* Main Content Area */}
      <main className="guest-main">
        {children}
      </main>

      {/* Floating AI chat bubble — visible on all guest pages */}
      <ChatBubble />
    </div>
  );
};

export default GuestLayout;
